import moment from 'moment'

export default{
  methods: {
    getMessage: function (val) {
      // testing that emit works from mixin
      this.$emit('showMessage')
    },
    convertToUiTime: function (item) {
      if (item !== undefined && item === '') {
        var emptyObj = {
          h: '',
          mm: '',
          A: ''
        }

        return emptyObj
      }

      var openTime = item.split(':')
      var hourNum = Number(openTime[0])
      var amPM = 'AM'
      if (hourNum === 0) {
        hourNum = 12
      } else if (hourNum > 12) {
        hourNum = hourNum - 12
        amPM = 'PM'
      } else if (hourNum === 12) {
        amPM = 'PM'
      }

      var convertedTime = {
        h: hourNum.toString(),
        mm: openTime[1],
        A: amPM
      }
      return convertedTime
    },
    convertFromUITime (hmsVal) {
      if (hmsVal === undefined || (hmsVal.A === '' &&
          hmsVal.h === '' &&
          hmsVal.mm === '')) {
        return ''
      }

      var hourStr = ''
      if (hmsVal.A === 'AM') {
        if (hmsVal.h === '12') {
          hourStr = '00'
        } else if (Number(hmsVal.h) >= 10) {
          hourStr = hmsVal.h.toString()
        } else {
          hourStr = '0' + hmsVal.h.toString()
        }
      } else {
        hourStr = (Number(hmsVal.h) + 12).toString()
      }
      return hourStr + ':' + hmsVal.mm + ':00'
    },
    convertToUiTimeNew: function (val) {
      var newTime = moment(val, 'HH:mm:ss').format('h:mma')
      return newTime
    },
    convertFromUiTimeNew: function (val) {
      var newTime = moment(val, 'h:mma').format('HH:mm:ss')
      return newTime
    },
    emitProp: function (input) {
      this.$emit('input', input)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/widgets/date-mixin.js